/**
 * @fileOverview: Backend services to access the user settings.
 */

import { getAuthenticatedFetchJSON, getAuthenticatedFetchRaw } from 'rio-fetch';
import { handleServiceException, sendError, showError } from '../utils/errorHandling';

export const NEWSLETTER_RESOURCE_PATH = '/user/settings/newsletter';
export const LANGUAGE_RESOURCE_PATH = '/user/settings/language';
export const USER_INFO_RESOURCE_PATH = '/whoami';
export const EDIT_USER_RESOURCE_PATH = '/users';
export const CDN_URL = 'https://translations.rio.cloud/usersettings';

export function getNewsletter(backend, fetch = fetch) {
    const configuredFetch = getAuthenticatedFetchJSON(fetch, document);

    const url = `${backend}${NEWSLETTER_RESOURCE_PATH}`;

    return configuredFetch(url, {
        headers: {
            Accept: 'application/json',
        },
        method: 'GET',
    }).catch(err => {
        sendError(err, 'getNewsletter');
    });
}

export function getLanguage(backend, fetch = fetch) {
    const configuredFetch = getAuthenticatedFetchJSON(fetch, document);

    const url = `${backend}${LANGUAGE_RESOURCE_PATH}`;

    return configuredFetch(url, {
        headers: {
            Accept: 'application/json',
        },
        method: 'GET',
    }).catch(err => {
        sendError(err, 'getLanguage');
    });
}

export function getMessages(locale) {
    const url = `${CDN_URL}/usersettings_${locale}.json`;

    return fetch(url)
        .then(response => response.json())
        .catch(err => {
            sendError(err, 'getMessages');
        });
}

export function getUserInfo(backend, fetch = fetch) {
    const configuredFetch = getAuthenticatedFetchJSON(fetch, document);

    const url = `${backend}${USER_INFO_RESOURCE_PATH}`;

    return configuredFetch(url, {
        headers: {
            Accept: 'application/json',
        },
        method: 'GET',
    }).catch(err => {
        if (err.status !== 401) {
            sendError(err, 'getUserInfo');
        }
    });
}

export function editUser(backend, user, fetch = fetch) {
    const configuredFetch = getAuthenticatedFetchJSON(fetch, document);

    const url = `${backend}${EDIT_USER_RESOURCE_PATH}`;

    return configuredFetch(url, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(user),
        method: 'PUT',
    }).catch((err) => {
        showError();
        sendError(err, 'editUser');
    });
}

export function updateLanguage(backend, language, fetch = fetch) {
    const configuredFetch = getAuthenticatedFetchRaw(fetch, document);

    const url = `${backend}${LANGUAGE_RESOURCE_PATH}`;
    return configuredFetch(url, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                preferredLanguage: language,
            }
        ),
        method: 'PUT',
    }).then((response) => {
        return {
            edited: response.status,
        };
    }).catch(err => {
        return handleServiceException(err, 'updateLanguage', false);
    });
}
